import { useI18n } from '@app-velocity/i18n';
import { useOpenTeamBilling } from '@app-velocity/libs/shared';
import {
  useCurrentTeamStore,
} from '@app-velocity/modules/teams';
import { Button, useModalContext } from '@app-velocity/ui';

export const SubscriptionButton = () => {
  const { t } = useI18n();
  const { closeModal } = useModalContext();
  const { teamId, workspaceId } = useCurrentTeamStore();
  const { openBilling } = useOpenTeamBilling(teamId || '', workspaceId || '');

  const handleClick = () => {
    closeModal();
    openBilling();
  };

  return (
    <Button
      fullWidth
      variant="contained"
      color="primary"
      onClick={handleClick}
    >
      {t('users:no_more_credits.upgrade')}
    </Button>
  );
};
